import { c as _c } from "react/compiler-runtime";
import { Cookie } from '@libs/common-next';
import { useOverrides } from '../../store';
import css from './actions.module.scss';
import { actions } from './config';
export const Actions = () => {
  const $ = _c(2);
  const {
    setOverride
  } = useOverrides();
  let t0;
  if ($[0] !== setOverride) {
    const onClick = type => () => {
      if (type === "reload") {
        return window.location.reload();
      }
      Cookie.remove("x-petm-override");
      setOverride({});
    };
    t0 = <>{Object.entries(actions).map(t1 => {
        const [type_0, action] = t1;
        return <div key={action.text} className={css.action}><button onClick={onClick(type_0)}><span>{action.icon}</span>{action.text}</button><span>{action.subtitle}</span></div>;
      })}</>;
    $[0] = setOverride;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};